import { Component, OnInit } from '@angular/core';
import { CartService } from '../../../services/cart.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { ConfirmationBoxComponent } from 'src/app/shared/elements/confirmation-box/confirmation-box.component';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { first, groupBy, isEmpty, reject } from 'lodash';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { MatDialog } from '@angular/material/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent implements OnInit {
  cartProducts: any;
  baseUrl = environment.BASE_URL;
  companyId = localStorage.getItem('customercompanyId');
  cartItems: any[] = [];
  customerName: any;
  // projectName = '';
  submitted: boolean = false;
  expectedDeliveryDate: any = new Date(
    new Date().getTime() + 7 * 24 * 60 * 60 * 1000
  )
    .toISOString()
    .split('T')[0];
  minDate: any = new Date(this.expectedDeliveryDate);
  today = new Date();
  documentInfo: any = {
    userType: 'Customer',
    documentUseFor: 'MRO',
    baseUrl: this.baseUrl,
  };
  fileUploadConfig = {
    //uploadLabel: 'Upload specifications',
    buttonName: 'Choose File',
    dragDropText: 'Drag & Drop File or',
    // maxFileText: '(Max file size: 100MB)',
    isMultiple: false,
    fileSizeLimit: 10485760 * 10, // 100 mb in bytes
    fileLocation: `customer/${this.companyId}/checkout`,
    fileFormats: '.xls, .xlsx, .pdf, .doc, .docx, .zip, .ppt', // supported file formats for file picker
  };
  resetFileUpload = false;
  cartItemsError: Map<number, any> = new Map();
  customerCountryName: string = '';
  createRfq!: FormGroup;
  paymentTermData: any;
  incotermLists: any;
  regionName: any;
  constructor(
    private cartService: CartService,
    private commonServices: CommonService,
    private toastr: ToastrService,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    public dialog: MatDialog
  ) {}
  ngOnInit() {
    this.expectedDeliveryDate = new Date(
      this.today.getTime() + 7 * 24 * 60 * 60 * 1000
    )
      .toISOString()
      .split('T')[0];
    this.getCartProducts();
    this.getCustomerName();
    this.createRfqForm();
    this.paymentTerm();
    this.getincoTerm();
    this.commonServices.sharedData$.subscribe({
      next: (data: any) => {
        if (data == 'logout') {
          this.cartItems = [];
        }
      },
    });
  }

  getCartProducts() {
    let cartApi = `${this.baseUrl}rfq/cart/getCartItem?companyId=${this.companyId}`;
    this.commonServices.getData(cartApi).subscribe((data) => {
      this.cartItems = data?.response;
      this.cartItems.forEach((item: any) => {
        item['deliveryDate'] = this.expectedDeliveryDate;
        item['requirements'] = '';
      });
      this.cartService.getCartItems(Number(this.companyId));
    });
  }

  getDates(event: any, product: any) {
    product.deliveryDate = event.target?.value;
    let newMinDate: any;
    this.cartItems.forEach((item: any) => {
      if (!newMinDate) {
        newMinDate = new Date(item.deliveryDate);
      }
      if (newMinDate > new Date(item.deliveryDate)) {
        newMinDate = new Date(item.deliveryDate);
      }
      this.minDate = newMinDate;
    });
  }

  getCustomerName() {
    let apiURL = `${this.baseUrl}customer/company-management/getCompanyDetails?companyId=${this.companyId}`;
    this.commonServices.getData(apiURL).subscribe((res) => {
      this.customerName = res.response.name;
      this.regionName = res.response.regionName;
      if (res.response.countryName == null) {
        this.toastr.error('Please update your profile to create RFQ');
      } else {
        this.customerCountryName = res.response.countryName;
      }
    });
  }

  paymentTerm() {
    let apiURL = `${this.baseUrl}common-service/payment-term`;
    this.commonServices.getData(apiURL).subscribe((res) => {
      this.paymentTermData = res.response;
    });
  }

  getincoTerm() {
    let apiUrl = `${this.baseUrl}common-service/incoterm`;
    this.commonServices.getData(apiUrl).subscribe((data: any) => {
      this.incotermLists = data.response;
    });
  }

  createRfqForm() {
    this.createRfq = new FormGroup({
      projectName: new FormControl('', Validators.required),
      paymentTerm: new FormControl('', Validators.required),
      incoTerm: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
    });
  }

  ngOnDestroy(): void {
    if (this.cartItems.length) {
      this.submitQuoteAttachmentsAndRFQ(false);
    }
  }

  submitQuoteAttachmentsAndRFQ(createRFQ = true) {
    if (!this.cartItems.length) {
      return;
    }
    if (
      this.minDate &&
      this.cartItems.some((cartItem: any) => cartItem.deliveryDate == '')
    ) {
      this.toastr.error(`Date is required for each RFQ item`);
      return;
    }
    const apiUrl = `${this.baseUrl}rfq/cart/updateCart`;
    this.commonServices.update(apiUrl, '', this.cartItems).subscribe({
      next: (data: any) => {
        if (createRFQ) {
          const rfqTemplateGroup: any = groupBy(this.cartItems, 'rfqTemplate');
          for (const key in rfqTemplateGroup) {
            if (Object.prototype.hasOwnProperty.call(rfqTemplateGroup, key)) {
              const lineItems = rfqTemplateGroup[key];
              this.requestRfq(key, lineItems);
            }
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.error?.status?.error?.message) {
          this.toastr.error(error.error.status.error.message);
        }
      },
    });
  }

  requestRfq(rfqTemplate: string, lineItems: any[]) {
    this.submitted = true;
    let apiURL = `${this.baseUrl}rfq/customer`;
    let payLoad = {
      customerId: Number(this.companyId),
      //companyId: Number(this.companyId),
      customerName: this.customerName,
      projectName: this.createRfq.value.projectName,
      // order: 1,
      category: [],
      subCategory: [],
      material: [],
      secondaryProcess: [],
      attachments: [],
      deliveryDate: this.minDate,
      rfqTemplate: [rfqTemplate],
      lineItems: lineItems,
      createdSource: 'shop',
      countryName: this.customerCountryName,
      paymentTerm: this.createRfq.value.paymentTerm,
      incoTerm: this.createRfq.value.incoTerm,
      address: this.createRfq.value.address,
      regionName: this.regionName,
    };
    this.commonServices
      .postDatawithoutHeaders(apiURL, payLoad)
      .subscribe((res) => {
        this.toastr.success(`${rfqTemplate} RFQ created successfully`);
        this.pushGtmEmailIdEvent();
        this.router.navigateByUrl('/thank-you');
      });
  }

  redirectToProduct(productId: number) {
    this.router.navigate([`/product/${productId}`]);
  }

  continueToShop(): void {
    this.router.navigateByUrl('/');
  }

  pushGtmEmailIdEvent() {
    const gtmTag = {
      event: 'Customer_Onboarding-Step-1',
      event_category: 'User Input',
      indirectMRO: 'submitted',
      userEmail: localStorage.getItem('userEmail') || '',
    };
    this.gtmService.pushTag(gtmTag);
  }

  // disableSubmitButton = true;
  // getProjectName(event: any) {
  //   this.projectName = event.target.value;
  //   if (this.projectName !== '' && this.cartItemsError.size == 0) {
  //     this.disableSubmitButton = false;
  //   } else {
  //     this.disableSubmitButton = true;
  //   }
  // }
  deleteCartItem(productName: string, productId: number): void {
    if (!productId) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Confirm delete ',
        content: `Are you sure you want to delete '${productName}' from cart ?`,
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.cartItems = reject(this.cartItems, (o: any) => {
          return o.productId == productId;
        });
        let setCompanyId = localStorage.getItem('customercompanyId');
        const apiUrl = `${this.baseUrl}rfq/cart/deleteCart?productId=${productId}&companyId=${setCompanyId}`;
        this.commonServices.delete(apiUrl).subscribe({
          next: (data: any) => {
            this.toastr.success(`Product ${productName} removed from cart`);
            this.cartService.getCartItems();
            if (this.cartItemsError.has(productId)) {
              this.cartItemsError.delete(productId);
            }
          },
          error: (error: HttpErrorResponse) => {
            if (error.error?.status?.error?.message) {
              this.toastr.error(error.error.status.error.message);
            }
          },
        });
      }
    });
  }

  fileUploadEvent(fileUploadEvent: any, productId: number): void {
    const fileUploadData: any = fileUploadEvent;
    this.cartItems.forEach((item: any) => {
      const firstFileUploadData: any = first(fileUploadData.attachment);
      if (
        item.productId == productId &&
        firstFileUploadData &&
        firstFileUploadData?.id &&
        firstFileUploadData.location
      ) {
        item.fileId = firstFileUploadData?.id;
        item.fileUrl = firstFileUploadData.location;
        item.attachment = firstFileUploadData;
      }
    });
    if (fileUploadData?.fileUploadStatus) {
      this.toastr.success('File updated successfully');
    }
  }

  deleteFileLocal(product: any) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'File will be deleted',
        content: 'Are you sure you want to delete this File?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        // .................
        this.cartItems.forEach((item: any) => {
          if (item.productId == product.productId) {
            item.attachment = null;
            item.fileId = null;
            item.fileUrl = '';
          }
        });
      }
    });
  }

  trackCart(index: number, cartitem: any) {
    return cartitem ? cartitem.id : undefined;
  }

  updateQuantity(event: any, productId: number): void {
    if (!event.target.valueAsNumber) {
      this.cartItemsError.set(productId, '');
    } else if (
      this.cartItemsError.has(productId) &&
      event.target.valueAsNumber
    ) {
      this.cartItemsError.delete(productId);
    }
    this.cartItems.forEach((item: any) => {
      if (item.productId == productId && event.target.valueAsNumber) {
        item.quantity = event.target.valueAsNumber;
      }
    });
  }

  updateRequirement(event: any, productId: number) {
    if (!event.target.value) {
      return;
    }
    this.cartItems.forEach((item: any) => {
      if (item.productId == productId && event.target.value) {
        item.requirements = event.target.value.trim();
      }
    });
  }

  iscreateRfqDisabled(): boolean {
    if (this.cartItemsError.size == 0 && this.createRfq.valid) {
      return false;
    }
    return true;
  }

  addQuantity(productId: number) {
    this.cartItems.forEach((item: any) => {
      if (item.productId == productId) {
        item.quantity += 1;
        const event = {
          target: {
            valueAsNumber: item.quantity,
          },
        };
        this.updateQuantity(event, productId);
      }
    });
  }

  minusQuantity(productId: number) {
    this.cartItems.forEach((item: any) => {
      if (item.productId == productId) {
        item.quantity -= 1;
        const event = {
          target: {
            valueAsNumber: item.quantity,
          },
        };
        this.updateQuantity(event, productId);
      }
    });
  }
}
